/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2020] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetInvInqIdentifiers = require('../services/GetInvInqIdentifiers');
var GetInvestigationInquirySubpoena = require('../services/GetInvestigationInquirySubpoena');
var SecInvInqSubpoenaEditView = require('../views/SecInvInqSubpoenaEditView');

module.exports = function(invInqId, subpoenaId) {
  NProgress.start();
  NProgress.set(0.6);

  $.when(GetInvInqIdentifiers(invInqId), GetInvestigationInquirySubpoena(subpoenaId))
    .done(function(identifiers, subpoena) {
      NavUtils.navigate('#sec/investigation-inquiry/' + invInqId + '/subpoena/' + subpoenaId + '/edit');
      Scaffold.content.show(
        new SecInvInqSubpoenaEditView({
          model: new Backbone.Model({
            invInqId: invInqId,
            subpoenaId: subpoenaId,
            identifiers: identifiers,
            subpoena: subpoena
          })
        })
      );
      NProgress.done();
    })
    .fail(function() {
      NProgress.done();
    });
};
